import { makeStyles } from '@material-ui/core'

export const useStyles = makeStyles((theme) => ({
  body: {
    backgroundColor: '#FFFFFF'
  },
  rowContainer: {
    display: 'flex',
    flexDirection: 'column',
    padding: theme.spacing(0, 2),
    whiteSpace: 'nowrap',

    '&.adminMode': {
      flexDirection: 'column-reverse',
      paddingTop: theme.spacing(4)
    },

    [theme.breakpoints.up('lg')]: {
      flexDirection: 'row !important',
      padding: '0 !important',
      width: '100%',
      gap: theme.spacing(3),

      '&.alt': {
        flexDirection: 'column-reverse !important',
        background: theme.palette.background.section,
        borderRadius: 10,
        border: `1px solid ${theme.palette.primary.main}`,
        position: 'relative',
        '& > div ': {
          width: 'auto',
          backgroundColor: 'transparent',
          marginTop: 0,
          border: 'none'
        },
        '& > div > div': {
          backgroundColor: 'transparent',
          border: 'none'
        },
        overflowX: 'hidden'
      }
    }
  },

  resultsContainer: {
    flexShrink: 0,
    padding: theme.spacing(0, 2),
    marginTop: theme.spacing(2),
    [theme.breakpoints.up('lg')]: {
      width: '65%'
    }
  },
  mainContainer: {
    [theme.breakpoints.up('lg')]: {
      margin: '0 auto',
      width: '95%',
      '&.alt': {
        paddingTop: theme.spacing(4),
        paddingBottom: theme.spacing(4),
        display: 'flex',
        gap: theme.spacing(3)
      }
    },
    [theme.breakpoints.up('xl')]: {
      width: '80%'
    }
  },
  leftColumn: {
    marginTop: theme.spacing(4),
    marginBottom: theme.spacing(2),
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(3),

    [theme.breakpoints.up('lg')]: {
      flexGrow: 1
    }
  },
  rightColumn: {
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: '#D9D9D966',
    borderRadius: 10,
    border: `1px solid ${theme.palette.primary.main}`,
    gap: theme.spacing(3),

    '& > div': {
      backgroundColor: 'transparent !important'
    },

    [theme.breakpoints.up('lg')]: {
      marginTop: theme.spacing(4),
      marginBottom: theme.spacing(2),
      width: 450,
      flexShrink: 0,
      alignItems: 'center'
    }
  },
  actionButtonBlock: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2),
    marginTop: theme.spacing(6),
    alignSelf: 'center'
  },
  editButton: {
    width: 285,
    height: 43,
    borderRadius: 20,
    '& span': {
      fontWeight: 700,
      fontSize: '1.125rem',
      color: `${theme.palette.primary.contrastText} !important`
    }
  },
  previewTitle: {
    fontWeight: 700,
    fontSize: '1.125rem',
    color: theme.palette.primary.main,
    textAlign: 'center',
    textDecoration: 'underline',
    marginTop: theme.spacing(2)
  }
}))
